'use es6';

import { PureComponent } from 'react';
import ProvideReferenceResolvers from 'reference-resolvers/ProvideReferenceResolvers';
import ConnectedAPIDropdown from 'customer-data-reference-ui-components/connector/ConnectedAPIDropdown';
import { jsx as _jsx } from "react/jsx-runtime";
export default (({
  referenceObjectType,
  referenceResolver
}) => {
  class ConnectedAPIDropdownProvider extends PureComponent {
    render() {
      return /*#__PURE__*/_jsx(ConnectedAPIDropdown, Object.assign({}, this.props, {
        referenceObjectType: referenceObjectType
      }));
    }
  }
  const provideResolvers = ProvideReferenceResolvers({
    [referenceObjectType]: referenceResolver
  });
  return provideResolvers(ConnectedAPIDropdownProvider);
});